// Override Settings
var boostPFSInstantSearchConfig = {
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};

(function() {
	BoostPFS.inject(this);

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {};

	SearchInput.prototype.afterBindEvents = function() {
		// Fix cannot close search suggestion when clicking overlay 
		document.addEventListener('click', function(e) {
			if(this.searchAutoComplete && this.searchAutoComplete.isOpen && e && e.target) {
				var $clickedElement = jQ(e.target);
				var isClickSuggestion = $clickedElement.closest('.' + Class.searchSuggestionWrapper).length > 0;
				if (isClickSuggestion) {
					this.searchAutoComplete.$element.hide();
					this.searchAutoComplete.searchInput.onCloseAutocomplete();
					this.searchAutoComplete.isOpen = false;
				}
			}
		}.bind(this), true);
	}

  InstantSearchResultBlock.prototype.getTemplate = function (tempType) {
      switch (tempType) {
          case 'dym':
              return `
                  <li class="{{class.searchSuggestionItem}} {{class.searchSuggestion}}-dym" aria-label="Did you mean">{{dymContent}}</li>
              `.trim();
          default:
              return `
                  <div class="{{class.searchSuggestionGroup}}" data-group="{{type}}" aria-label="{{label}}">
                      <ul>
                          <li class="{{class.searchSuggestionHeader}}-{{type}} {{class.searchSuggestionHeader}}" aria-label="{{label}}"><h2 class="pfs--heading">{{label}}</h2></li>
                          {{resultItems}}
                      </ul>
                  </div>
              `.trim();
      }
  }
  InstantSearchResultItemCollection.prototype.getTemplate = function () {
      return `
          <li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedDataTitle}}" role="option">
              <a tabindex="-1" href="{{searchLink}}"><h3 class="pfs--item">{{highlightedSuggestionResult}}</h3></a>
          </li>
      `.trim();
  }
  InstantSearchResultItemPage.prototype.getTemplate = function() {
      return `
          <li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedDataTitle}}" role="option">
              <a tabindex="-1" href="{{searchLink}}"><h3 class="pfs--item">{{highlightedSuggestionResult}}</h3></a>
          </li>
      `.trim();
  }
  InstantSearchResultItemPopular.prototype.getTemplate = function() {
      return `
          <li class="{{class.searchSuggestionItem}} {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedData}}" role="option">
              <a tabindex="-1" href="{{searchLink}}"><h3 class="pfs--item">{{highlightedSuggestionResult}}</h3></a>
          </li>
      `.trim();
  }
  InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
      switch (tempType) {
          case InstantSearchResultItemProduct.tempType.IMAGE:
              return `
                  <div class="{{class.searchSuggestion}}-left">
                      <img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">
                  </div>
              `.trim();
          case InstantSearchResultItemProduct.tempType.SKU:
              return `
                  <p class="{{class.searchSuggestion}}-product-sku">SKU: {{sku}}</p>
              `.trim();
          case InstantSearchResultItemProduct.tempType.VENDOR:
              return `
                  <p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
              `.trim();
          case InstantSearchResultItemProduct.tempType.PRICE:
              return `
                  <p class="{{class.searchSuggestion}}-product-price">
                      <span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
                  </p>
              `.trim();
          case InstantSearchResultItemProduct.tempType.PRICE_SALE:
              return `
                  <p class="{{class.searchSuggestion}}-product-price">
          <span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>&nbsp;
                      <s>{{compareAtPrice}}</s>
                      
                  </p>
              `.trim();
          default:
              return `
                  <li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
                      <a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
                          {{itemProductImage}}
                          <div class="{{class.searchSuggestion}}-right">
                              <h3 class="pfs--item {{class.searchSuggestion}}-product-title">{{title}}</h3>
                              {{itemProductSku}}
                              {{itemProductVendor}}
                              {{itemProductPrice}}
                          </div>
                      </a>
                  </li>
              `.trim();
      }
  }

     /* Start-Boost-237119 */
    Utils.reBuildUrlBaseOnLocale = function(url) {
        // remove http or https
        url = url.replace('https://', '').replace('http://', '');
        // Rebuild URL based on Shopify's routes object
        var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
        if (hasShopifyRoutes) {
            return Shopify.routes.root.replace(/\/$/, '') + url;
            // Rebuild URL based on published locales
        } else {
            var currentLocale = Settings.getSettingValue('general.current_locale');
            var publishedLocales = Settings.getSettingValue('general.published_locales');
            var publishedLocaleKeys = Object.keys(publishedLocales);
            var currentLocaleIndex = publishedLocaleKeys.indexOf(currentLocale);
            // If the locale isnt in the published list, or is default locale, return the normal url
            if (currentLocaleIndex < 0 || publishedLocales[currentLocale] == true) return url;
            var urlArr = url.split('/');
            if (urlArr.length > 1 && publishedLocaleKeys.length && currentLocale.length) {
                var isUrlHasLocaleString = publishedLocaleKeys.indexOf(urlArr[1]) > -1;
                if (isUrlHasLocaleString) {
                    urlArr[1] = currentLocale;
                } else {
                    urlArr.splice(1, 0, currentLocale);
                }
            }
            return urlArr.join('/');
        }
    }
    Utils.buildProductItemUrl = function(data, hasCollection) {
        // Get url information
        var params = Utils.getWindowLocation().search.substring(1);
        var pathname = window.location.pathname;
        var elements = pathname.split('/');
        // Check if has locale
        var localeURLPart = "";
        var hasShopifyRoutes = Shopify && Shopify.routes && typeof Shopify.routes.root != 'undefined';
        if (hasShopifyRoutes) {
            localeURLPart = Shopify.routes.root.replace(/\/$/, '');
        } else if (elements.indexOf(boostPFSAppConfig.general.current_locale) > -1) {
            localeURLPart = "/" + boostPFSAppConfig.general.current_locale;
        }
        // Get product handle
        var handle = typeof data === 'object' && data.hasOwnProperty('handle') ? data.handle : data;
        var hasCollection = typeof hasCollection !== 'undefined' ? hasCollection : Settings.getSettingValue('general.addCollectionToProductUrl');
        if (hasCollection) {
            // Homepage or Search page
            if (pathname == '/' || Utils.isSearchPage() || Utils.isVendorPage() || Utils.isTypePage()) {
                var preHandle = localeURLPart + '/collections/all/products/';
                return preHandle + handle;
                // Tag Page
            } else if (Utils.isTagPage()) {
                var preHandle = localeURLPart + '/collections/';
                var collectionHandleIndex = elements.indexOf("collections") + 1
                if (elements.length >= 4) return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
                return '/collections/all/products/' + handle;
            } else {
                // Google cache URL
                // An URL of Google cache will look like this: webcache.googleusercontent.com/search?q=cache:xxx:https://xxx.xxx/collections/xxx+&....
                if (params.indexOf('cache:') > -1) {
                    var collectionHandle = 'all';
                    var temp = params.split('&')[0].split('?')[0].split('collections/');
                    if (temp.length > 1) {
                        if (temp[1].indexOf('/') > -1) {
                            collectionHandle = temp[1].split('/')[0];
                        } else {
                            collectionHandle = temp[1];
                        }
                    }
                    collectionHandle = collectionHandle.replace(/[`~!@#$%^&*()_|+\=?;:'",.<>\{\}\[\]\\\/]/g, '');
                    return '/collections/' + collectionHandle + '/products/' + handle;
                }
                var collectionHandleIndex = elements.indexOf("collections") + 1
                var preHandle = localeURLPart + '/collections/';
                if (typeof elements[2] !== 'undefined') {
                    return preHandle + elements[collectionHandleIndex] + '/products/' + handle;
                }
                return window.location.pathname + '/products/' + handle;
            }
        }
        return localeURLPart + '/products/' + handle;
    };
    /* End-Boost-237119 */
})();